import Immutable from 'immutable';
import {
  FLAG_GETTING_MAINTENANCE_WARNINGS,
  GET_MAINTENANCE_WARNINGS,
  CLEAR_MAINTENANCE_WARNINGS,
  FLAG_MAINTENANCE_WARNING_ACTIVITY,
  CLEAR_MAINTENANCE_WARNING,
  GET_MAINTENANCE_WARNING,
  FLAG_GETTING_MAINTENANCE_WARNINGS_IN_SELECT,
  GET_MAINTENANCE_WARNINGS_IN_SELECT,
  CLEAR_MAINTENANCE_WARNINGS_IN_SELECT,
} from '../../../actions/types/mechanical-maintenance';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  allInSelect: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_MAINTENANCE_WARNINGS:
      return state.setIn(['all', 'loading'], payload);
    case GET_MAINTENANCE_WARNINGS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_MAINTENANCE_WARNINGS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['allInSelect', 'content']),
      );
    case FLAG_GETTING_MAINTENANCE_WARNINGS_IN_SELECT:
      return state.setIn(['allInSelect', 'loading'], payload);
    case GET_MAINTENANCE_WARNINGS_IN_SELECT:
      return state.setIn(['allInSelect', 'content'], Immutable.Map(payload));
    case CLEAR_MAINTENANCE_WARNINGS_IN_SELECT:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_MAINTENANCE_WARNING_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_MAINTENANCE_WARNING:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_MAINTENANCE_WARNING:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
